// extracted by mini-css-extract-plugin
export default {"tooltip":"xR-z","arrow":"yR-z"};